export default __webpack_public_path__ + "static/media/SOFTOOLS.a3120a99.png";